import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
import { Validators, FormControl } from "@angular/forms";
const _clone = (d) => JSON.parse(JSON.stringify(d));
const swal = require('sweetalert');
import * as uuid from 'uuid';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-view-payout-contact',
  templateUrl: './view-payout-contact.component.html',
  styleUrls: ['./view-payout-contact.component.scss']
})
export class ViewPayoutContactComponent implements OnInit { 
  CreatePayOutSecuritybtn:boolean=false;
  editbenificiary: boolean = false;
  deletebenificiary: boolean = false;
  verifystatus: boolean = false;
  hidebeneficiary: boolean = false;
Addbenficiary:boolean=false;
VirtualAccount:boolean=false;
PayOutSecuritybtn:boolean=false;
  viewpayout:boolean=true;
  newpayout:boolean=false;
  editpayout:boolean=false;
  deletepayout:boolean=false;
  ContactAxisTab=0;
  ContactYesbankTab=0;
  ContactIndusTab=0
   ZerpProcessors:boolean=true;
  YBprocessorvalue=0;
  ABprocessorvalue=0
  processortype=true;
  processorvalue=0;
  IndusPayoutAccountKeyId
  YesPayoutAccountKeyId:any;
  AxisPayoutAccountKeyId:any;
  processorlist=[];
  Yp=0;
  Ap=0;
  Ip=0
  ProcessorAccountdetails=[];
  YesBankTab:boolean=false;
  AxisTab:boolean=false;
  IndusTab:boolean=false;
  yesBankInfo:boolean=false;
  hidecustomervirtualacct:boolean=false;
  IndusBankInfo:boolean=false;
  IndusCurrentBalance:any;
  IndusUpdatedDatetime:any;
  IndusAccountNo:any;
 IndusBankRefereceId:any;
 IndusAccountHolderName:any;
 IndusBankCode:any;
 IndusAddress:any;
IndusCity:any;
 IndusState:any;
  IndusZipCode:any;

  AxisBankInfo:boolean=false;
  AxisBankCurrentBalance:any;
  AxisBankUpdatedDatetime:any;
  AxisBankAccountNo:any;
  AxisBankBankRefereceId:any;
  AxisBankAccountHolderName:any;
  AxisBankBankCode:any;
  AxisBankAddress:any;
  AxisBankCity:any;
  AxisBankState:any;
  AxisBankZipCode:any;
  
  YesBankCurrentBalance:any;
  YesBankUpdatedDatetime:any;
  YesBankAccountNo:any;
  YesBankBankRefereceId:any;
  YesBankAccountHolderName:any;
  YesBankBankCode:any;
  YesBankAddress:any;
  YesBankCity:any;
  YesBankState:any;
  YesBankZipCode:any;




  PayOutProcessorType= new FormControl("", [Validators.required]);
  myItems=[];
  private newAttribute: any = {};
  Processorvalue:any;
    PayOutprocessorList=[];
  ProcessorID=0;
  CreatePayOutSecurity:boolean=false;
  AccountHolderName:any;
  customeraccountbtn:boolean=false;
  accountIddetail:boolean=false;
  OrderRows=[];
  Accountdetail=[];
  Accountcreate:boolean=false;
  resellerno:any;
  CreateAccountbtn:boolean=false;
  excelTansactionDataResponse = [];
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "1" },
    { text: "current week", value: "2" },
    { text: "Last Week", value: "3" },
    { text: "This Month", value: "4" },
    { text: "Last Month", value: "5" },
    { text: "Custom Date Range", value: "6" }
  ];
  AccountNo= new FormControl("", [Validators.required]);
  PayOutBeneficiaryKeyId= new FormControl("", [Validators.required]);
  BankName= new FormControl("", [Validators.required]);
  editing = {};
  servicesslist=[];
  Filter = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;
  rowsSel = [];
  selected = [];
  MerchantKeyId:any;
  daterange = new FormControl("", [Validators.required]);
  filtering: boolean = false;
  Dfiltering: boolean = true;
  Rfromdate: boolean = false;
  isStartDateGreaterthenEndDate: boolean = false;
  isCustomDateSelected: boolean = false;
  isreportsbtnActive: boolean = false;
  fromdate = new FormControl("", [Validators.required]);
  Fromdate1: any;
  todate1: any;
  todate = new FormControl("", [Validators.required]);

  PCustomerkeyId:any;


  Bid:any;
  Customerid:any;
  rows;
  row = [];
  viewid:any;
  fltrMerchantkeyId:any;
  viewBeneficiariedetails:boolean=false;

  constructor(private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService,private router:Router) {
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
    });
this.getUserPermissions();
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.fltrMerchantkeyId = merchantdata.MerchantKeyId;
    this.service.ViewPayOutContactDetails(this.viewid, merchantdata.MerchantKeyId).subscribe(result => {
     this.rows=result;
     this.Bid=result.PayoutCustomerkeyId;
     this.PCustomerkeyId=result.PayoutCustomerkeyId;
     this.Customerid=result.CustomerAccountId;
     if(this.Customerid !=null && this.Customerid !="")
     {
       this.CreatePayOutSecuritybtn=true;
     }
     this.PayoutCreditAllowedAccountsdetails();
     this.GetcustomerAccountdetail();
    // this.CreateVirtualAccountbasedonprocessor();
     if(result!=null)
     {
      this.service.ViewPayOutBeneficiarie(this.Bid , merchantdata.MerchantKeyId).subscribe(res => {
        this.row=res;
        this.row.forEach(element => {
          if (element.AccountNumber !=null) {
          var first6digits = element.AccountNumber.slice(0, 6);
         var last4digits = element.AccountNumber.slice(-4);
            element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
          }
         
        });
  
       })
     }
    })


   
   }

   checkRangeType()
   {
     var daterange=this.daterange.value;
     if(daterange=="Custom Date Range")
     {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
         this.Rfromdate=true;
        this. Dfiltering=false;
        this.fromdate.setValue('');
        this.todate.setValue('');
        this.isreportsbtnActive = false;
     }
     else{
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate=false;   
     }
   }

   
   viewBeneficiarie()
   {
          this.viewBeneficiariedetails=true;
          this.accountIddetail=false;
          this.CreatePayOutSecurity=false;

          this.ZerpProcessors=true;
   }

   filters() {
    this.filtering = !this.filtering;
  }

   selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
      this.search();

    }
  }

  search() {
    this.GetPayOutcontactfilter((data) => {
      // cache our list
      this.temp = _clone(data);
      this.row = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);
      this.row.forEach(element => {
        if (element.AccountNumber !=null) {
        var first6digits = element.AccountNumber.slice(0, 6);
       var last4digits = element.AccountNumber.slice(-4);
          element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
        }
       
      });
    });
 
  }
  GetPayOutcontactfilter(cb) {
    var daterange = this.daterange.value;
    var pid = this.PayOutBeneficiaryKeyId.value;
    var AccountNumber = this.AccountNo.value;
    var Name = this.BankName.value;

    if (daterange == "Today") {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);


    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.Fromdate1 = tomorrow;
      this.todate1 = tomorrow;

    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));


      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);


    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Month") {
      // var date = new Date();                
      // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
      var date = new Date();
      this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();


    }
    else if (daterange == "Custom Date Range") {

      this.Fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;
    }
    else {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);
    }

    const req = new XMLHttpRequest();
    req.open('GET',
      environment.viewbenficiarieFilterdataurl + "?MerchantKeyId=" + this.fltrMerchantkeyId  + "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1 + "&AccountNumber=" + AccountNumber + "&PayOutBeneficiaryKeyId=" + pid +"&BankName=" +Name +"&CustomerkeyId=" +this.Bid);
    req.onload = () => {
      cb(JSON.parse(req.response));
    };

    req.send();
  }



  checkDateRange() {
    if (this.fromdate.value != "" && this.todate.value != "") {
      if (this.fromdate.value > this.todate.value) {
        this.isreportsbtnActive = false;
        this.isStartDateGreaterthenEndDate = true;
      }
      else {
        this.isreportsbtnActive = true;
        this.isStartDateGreaterthenEndDate = false;
      }
    }
    else {
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
    }
  }




  ngOnInit() {
    this.createCustomerAccount();
  }
 
  toggleAccordian(event) {
    const element = event.target;
    element.classList.toggle("active");
    const panel = element.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  }	
  readAndExportToExcelData() {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    if (this.rows.length > 0) {
      this.rows.forEach(element => {
      
        var manageTranArray = { 'PayoutCustomerkeyId': element.PayoutCustomerkeyId, 'PayOutBeneficiaryKeyId': element.PayOutBeneficiaryKeyId,
         'AccountNumber': element.AccountNumber, 'BankName': element.BankName, 'BranchName': element.BranchName, 'UpdatedDatetime': element.UpdatedDatetime}
        this.excelTansactionDataResponse.push(manageTranArray);
      });

      const manageTransactionWorkSheet = XLSX.utils.json_to_sheet(this.excelTansactionDataResponse,
         { header: ['PayoutCustomerkeyId', 'PayOutBeneficiaryKeyId', 'AccountNumber', 'BankName', 'BranchName', 'UpdatedDatetime'] });
      XLSX.utils.book_append_sheet(workBook, manageTransactionWorkSheet, 'ManageTransaction_tbl');
    }
    XLSX.writeFile(workBook, "Excel" + new Date().getTime() + '.xlsx');
    this.excelTansactionDataResponse = [];
  }


  verificationbenficiarie(bid)
  {
    this.row.forEach(element => {
      if (element.PayOutBeneficiaryKeyId == bid) {
       
        let form = {
          MerchantKeyId: 0,
          UniqueRequestId: "",
          PayOutType: "",
          PayOutDate: "",
          TransactionType: "",
          PaymentType: "",
          Amount: 0,
          PayOutBeneficiaryKeyId: "",
          PayoutCustomerkeyId: "",
        }
        let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
        form.MerchantKeyId = merchantdata.MerchantKeyId;
        const myId = uuid.v4();
        var uniqueid=myId.substring(0,9);
       form.MerchantKeyId= merchantdata.MerchantKeyId;
       form.UniqueRequestId= uniqueid;
       form.PayOutType= "Immediate";
       form.PayOutDate=  new Date().toString();
       form.TransactionType= "Debit";
       form.Amount= 1;
       form.PaymentType= "IMPS";
        form.PayOutBeneficiaryKeyId= bid;
        form.PayoutCustomerkeyId= element.PayoutCustomerkeyId;
       this.service.VerifyBeneficiary(form).subscribe(result => {
        
        if(result.ResponseCode==1)
        {
          swal("Verified", "Verified beneficiary", "success");
          this.router.navigate(["PayOut/PayOutTransactions"]);
        }
        else
        {
          swal("Pending", result.ResponseText, "warning");
          // this.router.navigate(["PayOut/PayOutTransactions"]);
        }
      });
      }
    });
  }
  
  





  CreateVirtualAccount()
  {
  if(this.Customerid !=null && this.Customerid !="")
  {
    let form = {
      MerchantKeyId: 0,
      PayoutCustomerkeyId: "",
      PayoutCustomerAccountKeyId: "",
      PayoutProcessor:0,

    }
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    form.MerchantKeyId = merchantdata.MerchantKeyId;
    form.PayoutCustomerkeyId=this.PCustomerkeyId;
    form.PayoutCustomerAccountKeyId= this.Customerid;
    if(this.ProcessorID==0 )
    {
      if(this.PayOutProcessorType.value=="IndusInd")
      {
        form.PayoutProcessor=1;
      }
      else if(this.PayOutProcessorType.value=="YesBank")
      {
        form.PayoutProcessor=2;
      }
      else if(this.PayOutProcessorType.value=="AxisBank")
      {
        form.PayoutProcessor=3;
      }
    }
    else{
      form.PayoutProcessor=this.ProcessorID;
    }
    this.service.AddVirtualAccount(form).subscribe(result => {
      if(result !=null)
      {
        this.openConfirmationDialog();
      }
    })
  }
  else
  {
    swal("", "Please update Customer AccountId", "warning");
  }
   
  }

  createCustomerAccount()
  {
    this.MerchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.resellerno =this.commonfunction.getUserMerchantData().ResellerId;
  this.service.getMerchantServicesAndFees(this.MerchantKeyId,this.resellerno).subscribe(result => {
    this.servicesslist = _clone(result);;
    this.servicesslist.forEach(element => {
      if (element.ServiceCode == "CVA" && element.Status==1) {
        this.CreateAccountbtn=true;
       }
      });

  });
  
  }


  GetcustomerAccountdetail()
  {
    var mid=+this.MerchantKeyId;
    this.service.CheckCustomerAccountdetail(mid,this.PCustomerkeyId).subscribe(result => {
      if(result.length >0)
      {
        // this.OrderRows=result;
        // this.OrderRows = _clone(result)
        // this.AccountHolderName=result[0].AccountHolderName;
         this.Accountcreate=false;
         this.customeraccountbtn=true;

        this.ProcessorAccountdetails=result;
        this.ProcessorAccountdetails.forEach(element => {
  
          if (element.PayoutProcessor == 1) 
          {
           
            // if(element.PayoutProcessor == 1 && element.Status == 1)
            // {
            //   // this.IndusBankInfo=true;
            //   this.Ip=1;
            // }
            this.Ip=1;
          //  this.IndusCurrentBalance=element.CurrentBalance;
           this.IndusUpdatedDatetime=element.UpdatedDateTime;
           this.IndusAccountNo=element.AccountNo;
           this.IndusBankRefereceId=element.BankRefereceId;
           this.IndusPayoutAccountKeyId=element.PayoutCustomerAccountKeyId;
            if(this.IndusBankRefereceId=="Indus")
            {
              this.IndusBankRefereceId="Indusind Bank";
            }
           this.IndusAccountHolderName=element.AccountHolderName;
           this.IndusBankCode=element.BankCode;
           this.IndusAddress=element.Address;
           this.IndusCity=element.City;
           this.IndusState=element.State;
           this.IndusZipCode=element.ZipCode;
          //  this.myItems.splice(, 1);

          } 
          else if (element.PayoutProcessor == 2 ) {
            // this.YesBankTab=true;
           
            // if(this.YBprocessorvalue==1 && element.Status == 1)
            // {
            //   // this.yesBankInfo=true;
            //   this.Yp=1;
            // }
             
            // this.YesBankCurrentBalance=element.CurrentBalance;
            this.Yp=1;
            this.YesBankUpdatedDatetime=element.UpdatedDateTime;
            this.YesBankAccountNo=element.AccountNo;
            this.YesBankBankRefereceId=element.BankRefereceId;
            this.YesBankAccountHolderName=element.AccountHolderName;
            this.YesBankBankCode=element.BankCode;
            this.YesBankAddress=element.Address;
            this.YesBankCity=element.City;
            this.YesBankState=element.State;
            this.YesBankZipCode=element.ZipCode;
            this.YesPayoutAccountKeyId=element.PayoutCustomerAccountKeyId;
         
          }
          else if (element.PayoutProcessor == 3)
           {
            // this.AxisTab=true;
            
            // if(this.ABprocessorvalue==1 && element.Status == 1)
            // {
            //   // this.AxisBankInfo=true;
            //   this.Ap=1;
            // }
             
            this.Ap=1;
            // this.AxisBankCurrentBalance=element.CurrentBalance;
            this.AxisBankUpdatedDatetime=element.UpdatedDateTime;
            this.AxisBankAccountNo=element.AccountNo;
            this.AxisBankBankRefereceId=element.BankRefereceId;
            this.AxisBankAccountHolderName=element.AccountHolderName;
            this.AxisBankBankCode=element.BankCode;
            this.AxisBankAddress=element.Address;
            this.AxisBankCity=element.City;
            this.AxisBankState=element.State;
            this.AxisBankZipCode=element.ZipCode;
            this.AxisPayoutAccountKeyId=element.PayoutCustomerAccountKeyId;
          }
         
        })

      }
      else{
        this.Accountcreate=true;
        this.customeraccountbtn=false;
      }
    });
  }
  dispalydetail()
  {
this.accountIddetail=true;
this.viewBeneficiariedetails=false;
  }


  
  openConfirmationDialog() {
    
    swal({
      title: 'customer virtual account created successfully ',
      text: '',
      icon: 'success',
      buttons: {
        
          confirm: {
              text: 'Ok',
              value: true,
              visible: true,
              className: "",
              closeModal: true
          }
      }
  }).then((isConfirm) => {
      if (isConfirm) {
      window.location.reload();
      }
    
  });
  
  }


// getdetails()
// {
//   let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
//   // this.loggedinuseremail = this.commonfunction.getUserId();
//   // this.loggedinuseremail=null;
  
// this.MerchantKeyId = merchantdata.MerchantKeyId;

//   this.PayoutCreditAllowedAccountsdetails((data) => {
//     // cache our list

//     this.Accountdetail = _clone(data);;
    
//     this.Accountdetail.forEach(element => {
//       if (element.AccountNumber !=null) {
//       var first6digits = element.AccountNumber.slice(0, 6);
//      var last4digits = element.AccountNumber.slice(-4);
//         element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
//       }
     
//     });

//   });

// }
 
PayoutCreditAllowedAccountsdetails() {
  let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.MerchantKeyId = merchantdata.MerchantKeyId;
  this.service.GetPayoutCreditAllowedAccountsdetails(this.MerchantKeyId,this.Customerid).subscribe(result => {
    this.Accountdetail = _clone(result);;
      
    this.Accountdetail.forEach(element => {
      if (element.AccountNumber !=null) {
      var first6digits = element.AccountNumber.slice(0, 6);
     var last4digits = element.AccountNumber.slice(-4);
        element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
      }
     
    });
  });
  // const req = new XMLHttpRequest();
  // req.open('GET', environment.GetPayoutCreditAllowedAccountsdetails + "?MerchantKeyId=" + this.MerchantKeyId + "&Id="+this.Customerid);
 
  // req.onload = () => {
  //   cb(JSON.parse(req.response));
  // };

  // req.send();
}

onKey()
{
  this.processortype=false;
}

CreateVirtualAccountbasedonprocessor(value)
{
  this.myItems=[];
  this.CreatePayOutSecurity=false;
   this.viewBeneficiariedetails=false;
   this.ZerpProcessors=false;

  let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetPayoutprocessor(merchantdata.MerchantKeyId).subscribe(res1 => {
    if(res1 !=null)
    {
      this.PayOutprocessorList= res1;
         if(res1.length==1 && res1[0].Status==1)
         {
            this.ProcessorID=res1[0].PayoutProcessorId;
            if(value==1)
            {
              this.CreateVirtualAccount();
            }
            else
            {
              this.accountIddetail=true;
              
            }
         }
         if(res1.length>1)
         {
           this.accountIddetail=true;
          this.PayOutprocessorList= res1;
          }

          this.PayOutprocessorList.forEach(element => {
            if (element.IsDefault ==1)
            {
              var processorId=element.PayoutProcessorId;
              if(processorId==0)
              {
               this.Processorvalue="PayGDemo";
              }
              else if(processorId==1)
              {
                this.Processorvalue="IndusInd";
              }
              else if(processorId==2)
              {
                this.Processorvalue="YesBank";
              }
              else if(processorId==3)
              {
                this.Processorvalue="AxisBank";
              }
              // this.processordelection();
            }
           });

           this.PayOutprocessorList.forEach(element => {
           
               if (element.PayoutProcessorId ==1&& element.Status ==1 && this.Ip==0  &&(element.PayoutAccountKeyId !="" && element.PayoutAccountKeyId !=null))
              {
               var PayoutProcessorId="IndusInd"
               var PayoutAccountKeyId=element.PayoutAccountKeyId;
               this.newAttribute = {PayoutAccountKeyId,PayoutProcessorId}; 
               this.myItems.push(this.newAttribute); 
               this.processorvalue=1;
              //  this.IndusBankInfo=true;
              }
              else if (element.PayoutProcessorId ==2 && element.Status ==1 && this.Yp==0  &&(element.PayoutAccountKeyId !="" && element.PayoutAccountKeyId !=null))
              {
                var PayoutProcessorId="YesBank"
               var PayoutAccountKeyId=element.PayoutAccountKeyId;
               this.newAttribute = {PayoutAccountKeyId,PayoutProcessorId}; 
               this.myItems.push(this.newAttribute); 
               this.YBprocessorvalue=1;
              //  this.yesBankInfo=true;
              }
              else if (element.PayoutProcessorId ==3 && element.Status ==1 &&this.Ap==0 &&(element.PayoutAccountKeyId !="" && element.PayoutAccountKeyId !=null))
              {
                var PayoutProcessorId="AxisBank"
               var PayoutAccountKeyId=element.PayoutAccountKeyId;
               this.newAttribute = {PayoutAccountKeyId,PayoutProcessorId}; 
               this.myItems.push(this.newAttribute); 
               this.ABprocessorvalue=1;
              //  this.AxisBankInfo=true;
              }
            });




            this.PayOutprocessorList.forEach(element => {
              // this.Ip=0;this.Yp=0; this.Ap=0;
                if (element.PayoutProcessorId == 1 && element.Status==1) 
                {
                  if(this.Ip==1)
                  {
                    this.ContactIndusTab=1;
                  }
                  else{
                    this.ContactIndusTab=0;
                  }
                  
                }
                if (element.PayoutProcessorId == 2 && element.Status==1) 
                {
                  if(this.Yp==1)
                  {
                   this.ContactYesbankTab=1;
                  }
                  else{
                    this.ContactYesbankTab=0;
                  }
                    // this.Yp=1;
                }
                if (element.PayoutProcessorId == 3 && element.Status==1) 
                {
                  //  this.Ap=1;
                   if(this.Ap==1)
                   {
                    this.ContactAxisTab=1
                   }
                   else{
                    this.ContactAxisTab=0;
                   }
                }
              });

              if (this.ContactAxisTab==1 )
              {
                this.AxisBankInfo=true;
              }
              else{
                this.AxisBankInfo=false;
              }
              if(this.ContactYesbankTab==1)
              {
                this.yesBankInfo=true;
              }
              else{
                this.yesBankInfo=false;
              }
              if(this.ContactIndusTab==1)
              {
                this.IndusBankInfo=true;
              }
              else{
                this.IndusBankInfo=false;
              }

            // if (this.Ap==1 )
            // {
            //   this.AxisBankInfo=true;
            // }
            // else{
            //   this.AxisBankInfo=false;
            // }
            // if(this.Yp==1)
            // {
            //   this.yesBankInfo=true;
            // }
            // else{
            //   this.yesBankInfo=false;
            // }
            // if(this.Ip==1)
            // {
            //   this.IndusBankInfo=true;
            // }
            // else{
            //   this.IndusBankInfo=false;
            // }
            if( this.myItems.length==0)
            {
             this.accountIddetail=false;
            }
            else{
              this.accountIddetail=true;
            }
     
    }
    else
    {

      this.ZerpProcessors=true;
    
      swal("Pending","Payout Processor Configuration is not setup Please contact Admin", "warning");
    }

   });
}


getUserPermissions() {
  const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetuserRoleBasedPermissions(merchantdata.UserId, "Merchant").subscribe(result => {
    if (result != null) {
      for (var i in result) {
        if (result[i].UserPermission == 'PayOut') {
          var type = result[i].Type;
          if (type == 'R') 
          {
              this.viewpayout=true;
              this.newpayout=false;
              this.editpayout=false;
              this.deletepayout=false;;
              this.Addbenficiary=false;
              this.VirtualAccount=false;
              this.PayOutSecuritybtn=false;
              this.editbenificiary=false;
              this.verifystatus = false;
              this.hidebeneficiary = false;
              this.deletebenificiary=false;

          }
         else if (type == 'RW') 
          {
            this.viewpayout=true;
            this.newpayout=true;
            this.editpayout=true;
            this.deletepayout=false;;
            this.Addbenficiary=true;
            this.VirtualAccount=true;
            this.PayOutSecuritybtn=true;
            this.editbenificiary=true;
            this.deletebenificiary=true;
            if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
            {
              this.verifystatus = true;
              this.hidebeneficiary = true;
        
            }
            else{
              this.verifystatus = false;
              this.hidebeneficiary = false;
              
            }
          }
         else if (type == 'RWD') 
          {
            this.viewpayout=true;
            this.newpayout=true;
            this.editpayout=true;
            this.deletepayout=true;
            this.Addbenficiary=true;
            this.VirtualAccount=true;
            this.PayOutSecuritybtn=true;
            this.editbenificiary=true;
            this.deletebenificiary=true;
            if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
            {
              this.verifystatus = true;
              this.hidebeneficiary= true;
              this.hidecustomervirtualacct=true;
            }
            else{
              this.verifystatus = false;
              this.hidebeneficiary= false;
              this.hidecustomervirtualacct=false;
            }
          }
        }
      }

    }

  });
}


PayOutSecurity()
{
  this.CreatePayOutSecurity=true;
  this.ZerpProcessors=true;
  this.viewBeneficiariedetails=false;
}
}